import PropTypes from "prop-types";
import { formatDate } from "../../../utils/date";
import Table from "../Tables/Table";

const TABLE_HEADERS = [
  "Klagekode",
  "Klage registrert dato",
  "Saksnummer klage",
  "Saksbehandler",
  "Kode sendt til OKF",
  "Nytt beløp",
  "Vedtak",
  "Begrunnelse",
  "Annen info",
  "Lenke klagebehandling",
];

const wsplussUrl = import.meta.env.VITE_WSPLUSS_URL;

const renderRow = (vedtak) => (
  <tr>
    <td>
      {vedtak.klagekode} - {vedtak.klagekodeTekst}
    </td>
    <td>
      {vedtak.vedtaksDato
        ? formatDate(new Date(vedtak.vedtaksDato), "dateShort")
        : null}
    </td>
    <td>
      <a
        href={`${wsplussUrl}${vedtak.saksnummer}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {vedtak.saksnummer}
      </a>
    </td>
    <td>{vedtak.saksbehandler}</td>
    <td>
      {vedtak.datoTilIne
        ? formatDate(new Date(vedtak.datoTilIne), "dateTimeWithSeconds")
        : null}
    </td>
    <td>{vedtak.belop}</td>
    <td>{vedtak.vedtakBeskrivelse}</td>
    <td>{vedtak.vedtakBegrunnelse}</td>
    <td>{vedtak.annenInfo}</td>
    <td>
      <a
        href={vedtak.urlVedtakKlagebehandling}
        target="_blank"
        rel="noopener noreferrer"
      >
        Klagebehandling
      </a>
    </td>
  </tr>
);

const Klagebehandlinginformasjon = ({ vedtak }) => (
  <section>
    <div className="detalj-ileggelse-header-wrapper">
      <h2>Klagebehandlinginformasjon</h2>
    </div>
    <div className="detalj-ileggelse-table-wrapper">
      <Table renderRow={renderRow} items={vedtak}>
        {TABLE_HEADERS.map((header) => (
          <th key={header}>{header}</th>
        ))}
      </Table>
    </div>
  </section>
);

Klagebehandlinginformasjon.propTypes = {
  vedtak: PropTypes.arrayOf(
    PropTypes.shape({
      klagekode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      klagekodeTekst: PropTypes.string,
      vedtaksDato: PropTypes.any,
      saksnummer: PropTypes.string,
      saksbehandler: PropTypes.string,
      datoTilIne: PropTypes.any,
      belop: PropTypes.any,
      vedtakBeskrivelse: PropTypes.string,
      vedtakBegrunnelse: PropTypes.string,
      annenInfo: PropTypes.string,
      urlVedtakKlagebehandling: PropTypes.string,
    }),
  ),
};

export default Klagebehandlinginformasjon;
